import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Dossier/UpdateUrgency', method: 'PUT', token: token })
}
